import React, { useEffect, useState, useRef } from 'react';
import useStyles from './styles';

import ScrumCard from '../ScrumCard';

var loop = null;

function ScrumRow({showTags, cols, id, onColsChange, onCardAdd}) {
  const c = useStyles();
  const [isDragging, setIsDragging] = useState(false);
  const [stg, setStg] = useState(null);
  const [currEl, setCurrEl] = useState(null);

  const colNames = ["Backlog", "Sprint", "To Do", "Doing", "Verify", "Done"]

  var actualElement = null;
  var mouseEvent = null;

 

  const allowDrop = (e) => {
    
    e.preventDefault()
  }

  const onDragOver = (e) => {
    if ([...e.target.classList].indexOf('droppable') !== -1) {
      e.target.style.paddingBottom = '100px'
    }
  } 
  const onDragLeave = (e) => {
    if ([...e.target.classList].indexOf('droppable') !== -1) {
      e.target.style.paddingBottom = '10px'
    }
  } 

  const onDragCapture = (e) => {
  }

  const onDrop = (e) => {
    const card = document.getElementById(e.dataTransfer.getData('Card'));
    var lastRowId = card.id.split('-')[2];
    if ([...e.target.classList].indexOf('droppable') !== -1 && lastRowId == id) {

      //e.target.appendChild(card);
      e.preventDefault();


      onChange(card, e.target);
    }

    var containers = [...document.querySelectorAll('.droppable')];
    containers.map(c => {
      c.style.paddingBottom = '10px';
    })
  }

 

  const onChange = (card, parent) => {
    var parentId = parent.id;
    var cardId = card.id;

    var lastColId = cardId.split('-')[1];
    var newColId = parentId.split('-')[1];
    var cardId = cardId.split('-')[0];
    // var lastRowId = cardId.split('-')[2];
    var rowId = id;

    var tempData = JSON.parse(JSON.stringify(cols));

    var tempCard = tempData[lastColId].cards[cardId];
    tempData[lastColId].cards.splice(cardId, 1);
    if (!tempData[newColId]) {
      tempData[newColId] = {cards: []}
    }
    tempData[newColId].cards.push(tempCard);
    onColsChange(tempData);
  }

  const onDragStart = (e) => {
    setIsDragging(e.target.id);
    
    // setStg(document.getElementById('staged'))
    // var stgel = document.getElementById('staged');
    // stgel.style.position = 'absolute';
    e.target.parentNode.style.zIndex = 5;
    // Set data transfer event
    e.dataTransfer.setData('Card', e.target.id);

  }
  const onDragEnd = (e) => {
    setIsDragging(false);

    // stg.style.position = null
    // stg.style.top = null
    // stg.style.left = null
  }

  const onDrag = (e) => {
    // stg.style.left = e.clientX - 100 +"px";
    // stg.style.top = e.clientY - 50 +"px";

  }

  const onTouchStart = (e) => {
    if (e.target.draggable !== true) {
      return false
    }

    var container =  document.querySelector('.row-'+id);

    // Disable scrolling
    var sl = container.scrollLeft;
    container.onscroll = (e) => {
      container.scrollTo(sl,0)
    }
    setIsDragging(e.target.id);
    setCurrEl(e.target);
    e.target.style.position = 'absolute';
  }
  
  const onTouchEnd = (e) => {
    if (e.target.draggable !== true) {
      return false
    }

    clearInterval(loop);
    var droppables = [...document.querySelectorAll('.droppable')];
    droppables.map(d => d.style.paddingBottom = "10px");
    var container =  document.querySelector('.row-'+id);
    // Resume scrolling
    container.onscroll = (e) => {};

    var t = e.touches;
    var containerPaddingLeft = parseInt(window.getComputedStyle(container, null).getPropertyValue('padding-left').replace("px", ""));
    var x = e.target.offsetLeft - containerPaddingLeft + container.scrollLeft;
    var col = Math.round(x / 250);

    var nextContainer = document.getElementById('col-'+col+"-"+id);
    var y = e.target.offsetTop - nextContainer.offsetTop;
    if (y < (e.target.offsetHeight / 2) * -1 || y > nextContainer.offsetHeight - (e.target.offsetHeight / 2)) {
    }
    else {
      //nextContainer.appendChild(e.target);
      onChange(e.target, nextContainer)
    }

    e.target.style.position = null;
    e.target.style.left = null;
    e.target.style.top = null;

  }

  const onTouchMove = (e) => {
    if (e.target.draggable !== true) {
      return false
    }

    var container = document.querySelector('.row-'+id);

    // MOVING
    var t = e.touches[0];
    var x = t.clientX;
    var y = t.clientY;
    if (x > window.innerWidth - (e.target.offsetWidth / 2)) {
      x = window.innerWidth - (e.target.offsetWidth / 2);
    }
    else if (x < (e.target.offsetWidth / 2)) {
      x = (e.target.offsetWidth / 2);
    }
    if (y > window.innerHeight - (e.target.offsetHeight / 2)) {
      y = window.innerHeight - (e.target.offsetHeight / 2);
    }
    else if (y < (e.target.offsetHeight / 2)) {
      y = (e.target.offsetHeight / 2)
    }
    currEl.style.top = y-(e.target.offsetHeight / 2)+"px";
    currEl.style.left = x-(e.target.offsetWidth / 2)+"px";
    // END MOVING

    // DETECTING FUTURE PARENT
    var containerPaddingLeft = parseInt(window.getComputedStyle(container, null).getPropertyValue('padding-left').replace("px", ""));
    var x = e.target.offsetLeft - containerPaddingLeft + container.scrollLeft;
    var col = Math.round(x / 250);
    var nextContainer = document.getElementById('col-'+col+"-"+id);
    var droppables = [...document.querySelectorAll('.droppable')];
    droppables.map(d => d.style.paddingBottom = "10px");
    nextContainer.style.paddingBottom = "100px";

    // END DETECTING FUTURE PARENT

    // AUTO SCROLLING
    var sl = container.scrollLeft;

    if (t.clientX < (e.target.offsetWidth + 100) ) {
      clearInterval(loop);

      loop = setInterval(() => {
        container.onscroll = (e) => {
        }
        container.scrollBy(-1, 0);
      }, 1)
    }
    else if (t.clientX > window.innerWidth ) {
      clearInterval(loop);
      
      loop = setInterval(() => {
        container.onscroll = (e) => {
        }
        container.scrollBy(1, 0);
      }, 1)
    }
    else {
      container.onscroll = (e) => {
        container.scrollTo(sl,0)
      }
      clearInterval(loop);
      loop = null;
    }
    // END AUTO SCROLLING
  }
  
  const onAdd = (colIndex) => {
    onCardAdd(id, colIndex);
  }

  useEffect(() => {
  }, [])

  return (
    <>
    {/* <div className={c.stagedItem} onDragCapture={onDragCapture} onDrop={onDrop} onDragOver={allowDrop}>
          <ScrumCard  id={"staged"} style={isDragging ? {display: 'block'} : {display: 'none'}} onDragStart={() => {}} onDragEnd={() => {}} onDrag={() => {}}></ScrumCard>
    </div>    */}
    <div className={c.rowContainer + " rowContainerSelector" + " row-"+id}>
      {colNames.map((colName, colIndex) => {
        return (
          <div key={colIndex} className={c.colContainer} onDragOver={onDragOver} onDragLeave={onDragLeave}>
            {showTags && <span>{colName}</span>}
            <div style={showTags ? {height: 'calc(100% - 81px)'} : {height: 'calc(100% - 30px)'}} className={c.colContainerItems + " droppable"} id={"col-"+colIndex + "-" + id}  onDragCapture={onDragCapture} onDrop={onDrop} onDragOver={allowDrop}>
              {cols[colIndex]?.cards?.map((card, cardIndex) => {
                return <ScrumCard rowIndex={id} colIndex={colIndex} cardIndex={cardIndex} onTouchMove={onTouchMove} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd} key={cardIndex} title={card.title || ""} description={card.description || ""} style={isDragging === 1 ? {opacity: '0'} : {opacity: '1'}} id={cardIndex + "-" + colIndex + "-" + id } onDragStart={onDragStart} onDragEnd={onDragEnd} onDrag={onDrag}></ScrumCard>
              })}
            </div> 
            <a className={c.add} onClick={() => onAdd(colIndex)}>Add Card</a>

          </div>
        )
      })}
      
    </div>
    </>
  );
}

export default ScrumRow;